module.exports = __webpack_public_path__ + "img/img-hyf-1.4046041e.png";